import React, { useState, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TourCard } from '../components/ui/Cards';
import { tours } from '../data';
import './ListPage.css';

export default function Tours() {
  const [searchParams] = useSearchParams();
  const [category, setCategory] = useState(searchParams.get('category') || 'all');
  const [sort, setSort] = useState('popular');
  const { t } = useTranslation();

  const filtered = useMemo(() => {
    let result = category === 'all' ? tours : tours.filter(t => t.category === category);
    if (sort === 'price-asc') result = [...result].sort((a, b) => a.price - b.price);
    if (sort === 'price-desc') result = [...result].sort((a, b) => b.price - a.price);
    if (sort === 'rating') result = [...result].sort((a, b) => b.rating - a.rating);
    return result;
  }, [category, sort]);

  const cats = [
    { key: 'all', label: t('tours.allTours') },
    { key: 'day-trips', label: t('tours.dayTrips') },
    { key: 'city-tours', label: t('tours.cityTours') },
  ];

  return (
    <>
      <div className="page-hero">
        <div className="container">
          <div className="section-tag">{t('tours.tag')}</div>
          <h1>{t('tours.title')}</h1>
          <p>12 expertly guided experiences from Marrakech</p>
        </div>
      </div>

      <section className="section section-white">
        <div className="container">
          <div className="list-controls">
            <div className="list-tabs">
              {cats.map(c => (
                <button
                  key={c.key}
                  className={`list-tab${category === c.key ? ' active' : ''}`}
                  onClick={() => setCategory(c.key)}
                >{c.label}</button>
              ))}
            </div>
            <div className="list-sort">
              <label>{t('tours.sortBy')}</label>
              <select value={sort} onChange={e => setSort(e.target.value)}>
                <option value="popular">{t('tours.popular')}</option>
                <option value="price-asc">{t('tours.priceLow')}</option>
                <option value="price-desc">{t('tours.priceHigh')}</option>
                <option value="rating">{t('tours.topRated')}</option>
              </select>
            </div>
          </div>
          <p className="list-count">{filtered.length} {t('tours.found')}</p>
          <div className="grid-4">
            {filtered.map(t => <TourCard key={t.id} tour={t} />)}
          </div>
        </div>
      </section>
    </>
  );
}
